import React from 'react'
import { ApolloProvider } from './providers'
import { MixpanelProvider } from 'react-mixpanel-browser'
import { LocationProvider } from '@reach/router'
import { ResetStoresOnRouteChange } from './components/resetStoresOnRouteChange'
import { Auth0Provider } from '@auth0/auth0-react'
const wrapRootElement = ({ element }) => {
  return (
    <Auth0Provider
      domain={process.env.AUTH0_DOMAIN}
      clientId={process.env.AUTH0_CLIENT_ID}
      redirectUri={process.env.AUTH0_CALLBACK_URL}
    >
      <ApolloProvider>
        <MixpanelProvider>
          <LocationProvider>
            <ResetStoresOnRouteChange>{element}</ResetStoresOnRouteChange>
          </LocationProvider>
        </MixpanelProvider>
      </ApolloProvider>
    </Auth0Provider>
  )
}

export default wrapRootElement
